import { Avatar, AvatarContent, AvatarDescription, AvatarImage, AvatarTitle } from '@playbooks/ui/components/avatar';
import { AvatarFallback } from '@playbooks/ui/components/avatar';
import { Icon, resolveIcon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';
import { truncate } from '@playbooks/utils';

export const SectionAvatar = ({ icon, thumbnail, title, text, href }) => (
	<Link variant='ghost' href={href} className='group h-auto p-0'>
		<Avatar className='flex-start gap-4'>
			{thumbnail ? (
				<AvatarImage size='md' src={thumbnail} alt={title} />
			) : (
				<AvatarFallback size='md'>
					<Icon {...resolveIcon(icon, 'fad')} aria-hidden />
				</AvatarFallback>
			)}
			<AvatarContent>
				<AvatarTitle className='group-hover:underline'>{title}</AvatarTitle>
				<AvatarDescription>{truncate(text, 60)}</AvatarDescription>
			</AvatarContent>
		</Avatar>
		<Icon data-icon='inline-end' type='far' icon='chevron-right' aria-hidden />
	</Link>
);
